// Route Code Edited 12/5/25
(function() {
    const DRAWER_CART_SELECTOR = 'cart-drawer.is-open';
    let isRunning;
    const run = () => {
        if (isRunning) return;
        const hasOpenDrawer = !!document.querySelector(DRAWER_CART_SELECTOR);
        const isCartPage = /\/cart\/?$/.test(location.pathname);
        if (!hasOpenDrawer && !isCartPage) return;
        isRunning = true;
        fetch('/cart.js').then(res => res.ok ? res.json() : Promise.reject(res.status)).then(cart => {
            const route = (cart.items || []).find(item => item.vendor === 'Route');
            if (route?.key) {
                return fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates:{[route.key]:0}})});
            }
        }).catch(() => {}).finally(() => {
            location.reload();
        });
    };
    addEventListener('pageshow', e => e.persisted && run());
    addEventListener('popstate', () => setTimeout(() => run(), 100));
})();
// End Route Code